// import PublicDonator from "@/viewing/public/donator.js";
import DonatorPrivate from "@/viewing/private/donator.js";
import DonatorPublic from "@/viewing/public/donator.js";
import RegularPrivate from "@/viewing/private/regular.js";

export default class Viewer {
  constructor(data, userRoom) {
    this.g = data;
    this.userRoom = userRoom;
    this.view = null;
  }
  init() {
    this.g.$socket.emit("viewer get room type", this.userRoom, room => {
      if (!room) {
        this.g.$root.$alert("Sorry!", "That room doesn't exist or isn't open.");
        this.g.closeViewer();
      } else if (room.type == "regular private") {
        this.view = new RegularPrivate(this.g, room.id);
        this.g.roomID = room.id;
        this.view.init();
      } else if (room.type == "donator private") {
        this.view = new DonatorPrivate(this.g, room.id);
        this.g.roomID = room.id;
        this.view.init();
      } else if (room.type == "donator public") {
        this.view = new DonatorPublic(this.g, room.id);
        this.g.roomID = room.id;
        this.view.init();
      }
    });
  }
  close(callback) {
    if (this.view) {
      this.view.close(callback);
    }
  }
}
